import {NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA} from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DinaUppgifterPageComponent } from './modules/berakningshjalpen/pages/dina-uppgifter/dina-uppgifter';
import {ResultatPageComponent} from './modules/berakningshjalpen/pages/resultat/resultat.page';
import {RouterGuard} from './modules/core/guards/router-guard.service';

const routes: Routes = [
  {
    path: '',
    component: DinaUppgifterPageComponent },
  {
    path: 'ditt-underlag/resultat',
    component: ResultatPageComponent,
    canActivate: [ RouterGuard ],
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppRoutingModule { }
